import { CookieStorage }  from './';

export class StorageFactory {
  _browser

  constructor(browser) {
    this._browser = browser
  } 

  getStorage() {
    console.info("XPSession:", 'Using Cookie Storage');
    return new CookieStorage();
  }
}
